export default __webpack_public_path__ + "5586cfd94c82591f4f8a411f600686f8.svg";